import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

interface MainLayoutProps {
  children?: React.ReactNode; // Optional, since we use Outlet
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => (
  <div className="bg-offwhite-100">
    <Header />
    <div className="">
      <main>
        {children} {/* Render the child route here */}
      </main>
      <Footer />
    </div>
  </div>
);

export default MainLayout;
